module.exports = __webpack_public_path__ + "img/img-8.0e6b761c.jpg";